<script setup lang="ts">
  import type { NuxtError } from '#app'

  const props = defineProps({
    error: Object as () => NuxtError,
  })

  console.log(props.error)

</script>

<template>
  <UError
    :error="{
      statusCode: props.error?.statusCode,
      statusMessage: $t('labels.errorPaginaNoEncontrada'),
      message: props.error?.message
    }"
    :clear="{
      color: 'neutral',
      size: 'lg',
      icon: 'i-lucide-arrow-left',
      class: 'rounded-full'
    }"
  />
</template>